import React from "react";
import { Col, Container, Row } from "reactstrap";
import ForgetPassword from "./ForgetPassword";

export default function SignIn() {
  return (
    <Container className="p-0" fluid>
      <ForgetPassword />
    </Container>
  );
}
